import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "@/mock";

export const FAQSection = () => {
    return (
        <section className="py-16 relative overflow-hidden">
            <div
                className="absolute z-0 left-[20%] rotate-45 top-[-10%] w-[40vw] ml-[5vw] h-[120%] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/list.svg')" }}
            />
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h2 className="font-serif text-3xl text-olive-950">FAQ</h2>
                <Accordion type="single" collapsible className="mt-6">
                    {FAQS.map((f, idx) => (
                        <AccordionItem key={idx} value={`item-${idx}`} className="bg-white/5 backdrop-blur-sm border rounded-xl mb-3 border-olive-100">
                            <AccordionTrigger className="px-4">{f.q}</AccordionTrigger>
                            <AccordionContent className="px-4 text-olive-900/80">{f.a}</AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
